<div class="container-fluid ptCustom">

    <div class="row mt-4 settingsTabs">

        <!-- tabs -->
        <div class="col-md-3">
            <ul class="nav flex-column nav-pills nav-fill" id="settingsTab" role="tablist">
                <li class="nav-item" role="presentation">
                    <button class="nav-link active text-start" id="general-tab" data-bs-toggle="tab" data-bs-target="#general-tab-pane" type="button" role="tab" aria-controls="general-tab-pane" aria-selected="true">General</button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link text-start" id="photo-tab" data-bs-toggle="tab" data-bs-target="#photo-tab-pane" type="button" role="tab" aria-controls="photo-tab-pane" aria-selected="false">Login Photo</button>
                </li>
            </ul>
        </div>

        <!-- tab content -->
        <div class="col-md-9">
            <div class="tab-content" id="settingsTabContent">

                <div class="tab-pane fade show active" id="general-tab-pane" role="tabpanel" aria-labelledby="general-tab" tabindex="0">
                    <div class="card shadow-sm rounded-lg">
                        <div class="card-body p-4">
                            <div class="row mb-3">
                                <div class="col-md-6">
                                    <div class="mb-3">
                                        <label for="exampleSetting1" class="form-label">Pending News Notification Email</label>
                                        <input [(ngModel)]="NewsEmail" type="text" class="form-control" id="exampleSetting1" placeholder="name@example.com">
                                        <label for="exampleSetting1" class="form-label">Pending Ads Notification Email</label>
                                        <input [(ngModel)]="AdsEmail" type="text" class="form-control" id="exampleSetting3" placeholder="name@example.com">
                                        <label for="exampleSetting1" class="form-label">Pending Letters Notification Email</label>
                                        <input [(ngModel)]="LettersEmail" type="text" class="form-control" id="exampleSetting4" placeholder="name@example.com">
                                        <label for="exampleSetting1" class="form-label">Pending Discount Notification Email</label>
                                        <input [(ngModel)]="DiscountEmail" type="text" class="form-control" id="exampleSetting5" placeholder="name@example.com">
                                        <label for="exampleSetting1" class="form-label">Pending Applications Notification Email</label>
                                        <input [(ngModel)]="ApplicationEmail" type="text" class="form-control" id="exampleSetting6" placeholder="name@example.com">
                                    </div>
                                    <!-- <div class="mb-3">
                                        <label for="exampleSetting2" class="form-label">Example</label>
                                        <textarea class="form-control" id="exampleSetting2" rows="3"></textarea>
                                    </div> -->
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="text-end">
                                    <button type="button" (click)="SaveNewSettings()" class="btn btn-sb border-lb shadow-sm"><i class="fa-regular fa-save"></i> Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="tab-pane fade" id="photo-tab-pane" role="tabpanel" aria-labelledby="photo-tab" tabindex="0">
                    <div class="card shadow-sm rounded-lg">
                        <div class="card-body p-4">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="mb-3">
                                        <label for="loginPhotoUpload" class="form-label">Photo on Login Page</label>
                                        <input (change)="updateLoginImage($event.target.files)" class="form-control" type="file" id="loginPhotoUpload">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="mb-3">
                                        <!-- jade note firefox https://getbootstrap.com/docs/5.3/forms/form-control/#color -->
                                        <label for="overlaySelect" class="form-label">Overlay Color</label>
                                        <input type="color" class="form-control form-control-color" id="overlaySelect" value="#ffffff" [(ngModel)]="selectedColor" title="Choose your color">
                                    </div>
                                    <div class="mb-3">
                                        <label for="opacitySlider" class="form-label">Overlay Opacity</label>
                                        <input type="range" class="form-range" min="0" max="1" step="0.1" value="0.4" [(ngModel)]="opacityValue" id="opacitySlider">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="text-end">
                                        <button type="button" (click)="SaveLoginSetting()" class="btn btn-sb border-lb shadow-sm"><i class="fa-regular fa-save"></i> Save</button>
                                        <button *ngIf="loginPhotoUrl != ''" type="button" (click)="showLiveToggle()" class="btn btn-outline-sb border-sb text-white shadow-sm"><i class="fa-regular fa-eye"></i> Live Preview</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="showLive" class="card shadow-sm rounded-lg mt-3">
                        <div class="card-body p-4">
                            <div class="row">
                                <div class="col-12">
                                    <h3 class="mb-3">Photo Preview</h3>
                                </div>
                                <div class="col-12">
                                    <div class="loginPreviewImg">
                                        <!-- inline styles -->
                                        <div class="previewOverlay" [style.background]="selectedColor" [style.opacity]="opacityValue"></div>
                                        <img [src]="loginPhotoUrl" alt="login photo preview" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>




    </div>











</div>